//src/pages/admin/adminApi.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const adminLogin = async (username, password) => {
  const response = await axios.post(`${API_URL}/admin/fortress-entry-admin-login`, { username, password });
  return response.data;
};

export const fetchMetrics = async (token, start_date, end_date) => {
  const response = await axios.get(`${API_URL}/admin/metrics`, {
    headers: { Authorization: `Bearer ${token}` },
    params: { start_date, end_date },
  });
  return response.data;
};

export const sendContactEmail = async (payload) => {
  const response = await axios.post(`${API_URL}/admin/emailTransporter`, payload);
  return response.data;
};

export const sendLiveDemoEmail = async (payload) => {
  axios.post(`${API_URL}/admin/live-demo`, payload);
};